import { render, staticRenderFns } from "./Handover.vue?vue&type=template&id=4147d623&scoped=true"
import script from "./Handover.vue?vue&type=script&lang=js"
export * from "./Handover.vue?vue&type=script&lang=js"
import style0 from "./Handover.vue?vue&type=style&index=0&id=4147d623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4147d623",
  null
  
)

export default component.exports